export const HIRE_CONTRACT_SIGN_PROCESS_TASK_NAME = 'HIRE_CONTRACT_SIGNING';
export const CONTRACT_EXTENSION_SIGN_PROCESS_TASK_NAME = 'CONTRACT_EXTENSION_SIGNING';
export const CONTRACT_EXTENSION_COMPANY_NOT_SIGN_PROCESS_TASK_NAME = 'CONTRACT_EXTENSION_COMPANY_NOT_SIGNING';
export const CONTRACT_EXTENSION_EMPLOYEE_NOT_SIGN_PROCESS_TASK_NAME = 'CONTRACT_EXTENSION_EMPLOYEE_NOT_SIGNING';
export const EXIT_CONTRACT_SIGNING_PROCESS_TASK_NAME = 'EXIT_CONTRACT_SIGNING';
